// export const __BASEURL__ = process.env.REACT_APP_BASE_URL;
// export const __VERSION__ = process.env.REACT_APP_VERSION;
// export const __TITLE__ = process.env.REACT_APP_TITLE;
// export const __DEV__ = process.env.NODE_ENV === 'development';
// import { Config } from 'types/common';

declare global {
  interface Window {
    config?: any;
  }
}

let configData = window.config

export const __BASEURL__ = configData?.apiUrl || process.env.REACT_APP_BASE_URL;

export const __ORTHERURL__ =
  process.env.REACT_OTHER_URL || 'http://42.96.53.22:9030';

export const __VERSION__ = process.env.REACT_APP_VERSION;
export const __TITLE__ = process.env.REACT_APP_TITLE;
export const __DEV__ = process.env.NODE_ENV === 'development';


